module.exports = __webpack_public_path__ + "img/bg2.fd0b68be.png";